import { MetaSkillsCodeToIcon } from 'const';

export const getRootMetaskillIconElement = (code: number) => {
  const IconComponent = MetaSkillsCodeToIcon[code];
  return IconComponent ? <IconComponent /> : null;
};
